export const employeeHrKeys = {
  root: ["employee-hr"] as const,
  selfProfile: () => ["employee-hr", "self-profile"] as const,
  selfOperationalHistory: (options: unknown) =>
    ["employee-hr", "self-operational-history", options] as const,
  selfOperationalHistoryRecord: (recordId: number) =>
    ["employee-hr", "self-operational-history-record", recordId] as const,
  selfContacts: () => ["employee-hr", "self-contacts"] as const,
  selfLeaveBalances: () => ["employee-hr", "self-leave-balances"] as const,
  selfLeaveRequests: (options: unknown) => ["employee-hr", "self-leave-requests", options] as const,
  employeeProfiles: (options: unknown) => ["employee-hr", "employee-profiles", options] as const,
  employeeProfile: (id: number) => ["employee-hr", "employee-profile", id] as const,
  officerOperationalHistory: (id: number, options: unknown) =>
    ["employee-hr", "officer-operational-history", id, options] as const,
  officerOperationalHistoryRecord: (officerProfileId: number, recordId: number) =>
    ["employee-hr", "officer-operational-history-record", officerProfileId, recordId] as const,
  officerDisciplinaryHistory: (id: number) => ["employee-hr", "officer-disciplinary-history", id] as const,
  officerIncidentHistory: (id: number) => ["employee-hr", "officer-incident-history", id] as const,
  officerTrainingHistory: (id: number) => ["employee-hr", "officer-training-history", id] as const,
  officerPerformanceHistory: (id: number) => ["employee-hr", "officer-performance-history", id] as const,
  officerContacts: (id: number) => ["employee-hr", "employee-contacts", id] as const,
  securityLicenses: (id: number) => ["employee-hr", "security-licenses", id] as const,
  securityLicenseTypes: () => ["employee-hr", "security-license-types"] as const,
  workEligibility: (id: number | "self") => ["employee-hr", "work-eligibility", id] as const,
  workAuthorizations: (id: number) => ["employee-hr", "work-authorizations", id] as const,
  licenseCompliance: (options: unknown) => ["employee-hr", "license-compliance", options] as const,
  leaves: (options: unknown) => ["employee-hr", "leaves", options] as const,
  expiringLicenses: (options: unknown) => ["employee-hr", "expiring-licenses", options] as const,
  leavePolicies: (companyId: number) => ["employee-hr", "leave-policies", companyId] as const,
};
